import React from 'react';
import {UiConfigContext} from 'src/internal/contexts/UiConfigContext';

import type {UiConfig} from 'src/types';

type Props = {
  config: UiConfig;
  children: React.ReactNode;
};

const UiProvider: React.FC<Props> = ({config, children}) => {
  return (
    <UiConfigContext.Provider value={config}>
      {children}
    </UiConfigContext.Provider>
  );
};

export default UiProvider;
